/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    Button,
    Card,
    Divider,
    Input,
    Modal,
    Select,
    Space,
    Spin,
    Tabs,
    Tag,
} from "antd";
import { useMemo, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { CardBody } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import InformationsGenerales from "./sections/InformationsGenerales";
import DeclarationTab from "./sections/DeclarationTab";
import FicheDeclarationTab from "./sections/FicheDeclarationTab";
import VictimesTab from "./sections/VictimesTab";
import AdversairesTab from "./sections/AdversairesTab";
import SapTab from "./sections/SapTab";
import ReglementsTab from "./sections/ReglementsTab";
import ExpertsTab from "./sections/ExpertsTab";
import PrisesEnChargeTab from "./sections/PrisesEnChargeTab";
import OffresSection from "./sections/OffresSection";
import DocumentsAFournir from "./DocumentsAFournir";
import DiscussionsTab from "./sections/DiscussionsTab";

const Details = ({
    sinistre,
    modalQuittance,
    victimes,
    quittance,
    captures,
    setRefetch,
    onDecaissementUpdated,
    name,
    ordreDepense,
    addItem,
    onNameChange,
    setModalFicheDemandeReglement,
    setFicheDemandeReglement,
    setModalQuittance,
    modalOrdreDepense,
    setQuittance,
    setSelectedGaranties,
    setModalOrdreDepense,
    setGarantieState,
    setOrdreDepense,
    provisionGaranties,
    inputRef,
    evaluations,
    setModalReevaluation,
    items,
    setMotifRevisionState,
    montant,
    montantPaye,
    setEditMode,
    removeProvisionFormFields,
    setProvisionGarantie,
    decaissements,
    valueSelected,
    editMode,
    addProvisionFormFields,
    setDecaissement,
    initEvaluation,
    setValueSelected,
    decaissement,
    loadingSinistre,
    setEvaluation,
    onSinistreUpdate,
    handleChange,
    setModalCloture,
    setModalSuspension,
    experts,
    expertises,
    captured,
    handleSubmit,
    garanties,
    ficheDemandeReglement,
    modalFicheDemandeReglement,
    selectedGaranties,
    evaluation,
    modalReevaluation,
    loadingSuspension,
    modalCloture,
    handleSuspensionDossier,
    modalSuspension,
    loadingCloture,
    handleClotureDossier,
}) => {
    const navigate = useNavigate();
    const [tabId, setTabId] = useState("1");
    const [modalAssignCheque, setModalAssignCheque] = useState(false);
    const [modalRemiseCheque, setModalRemiseCheque] = useState(false);
    const [modalAnnulerCheque, setModalAnnulerCheque] = useState(false);

    const isMobileSinistre = sinistre?.mobile;

    const evaluationCourante = useMemo(
        () => (evaluations?.filter((evaluationItem) => evaluationItem.courant === true) || [])[0] || null,
        [evaluations]
    );

    // console.log("Evaluation courante:", evaluationCourante);

    const onTabsChange = (key) => {
        setTabId(key);
    };

    const handleReevaluationClick = () => {
        if (sinistre?.codeId) {
            navigate(`/evaluation-sinistre`, {
                state: {
                    iz: sinistre.codeId,
                },
            });
        }
    };

    const tabItems = [
        {
            key: "1",
            label: "Détails",
            children: (
                <InformationsGenerales
                    sinistre={sinistre}
                    setRefetch={setRefetch}
                    isMobileSinistre={isMobileSinistre}
                    montant={montant}
                    montantPaye={montantPaye}
                    modalCloture={modalCloture}
                    setModalCloture={setModalCloture}
                    loadingCloture={loadingCloture}
                    modalSuspension={modalSuspension}
                    setModalSuspension={setModalSuspension}
                    loadingSuspension={loadingSuspension}
                    handleClotureDossier={handleClotureDossier}
                    handleSuspensionDossier={handleSuspensionDossier}
                    onSinistreUpdate={onSinistreUpdate}
                />
            ),
        },
        {
            key: "2",
            label: "Déclaration",
            children: <DeclarationTab sinistre={sinistre} />,
        },
        {
            key: "3",
            label: "Fiche de déclaration",
            children: <FicheDeclarationTab sinistre={sinistre} />,
        },
        {
            key: "4",
            label: "Victimes",
            children: (
                <VictimesTab
                    sinistre={sinistre}
                    victimes={victimes}
                    setRefetch={setRefetch}
                    editMode={editMode}
                    setEditMode={setEditMode}
                />
            ),
        },
        {
            key: "5",
            label: "Partie(s) adverse(s)",
            children: (
                <AdversairesTab
                    sinistre={sinistre}
                    victimes={victimes}
                    setRefetch={setRefetch}
                />
            ),
        },
        {
            key: "6",
            label: "Evaluations",
            children: (
                <SapTab
                    sinistre={sinistre}
                    evaluations={evaluations}
                    onReevaluationClick={handleReevaluationClick}
                />
            ),
        },
        {
            key: "7",
            label: "Règlements",
            children: (
                <ReglementsTab
                    sinistre={sinistre}
                    decaissements={decaissements}
                    evaluationCourante={evaluationCourante}
                    modalQuittance={modalQuittance}
                    setModalQuittance={setModalQuittance}
                    quittance={quittance}
                    setQuittance={setQuittance}
                    modalFicheDemandeReglement={modalFicheDemandeReglement}
                    setModalFicheDemandeReglement={setModalFicheDemandeReglement}
                    ficheDemandeReglement={ficheDemandeReglement}
                    setFicheDemandeReglement={setFicheDemandeReglement}
                    modalOrdreDepense={modalOrdreDepense}
                    setModalOrdreDepense={setModalOrdreDepense}
                    ordreDepense={ordreDepense}
                    setOrdreDepense={setOrdreDepense}
                    modalAssignCheque={modalAssignCheque}
                    setModalAssignCheque={setModalAssignCheque}
                    modalRemiseCheque={modalRemiseCheque}
                    setModalRemiseCheque={setModalRemiseCheque}
                    modalAnnulerCheque={modalAnnulerCheque}
                    setModalAnnulerCheque={setModalAnnulerCheque}
                    decaissement={decaissement}
                    setDecaissement={setDecaissement}
                    montant={montant}
                    setRefetch={setRefetch}
                    onDecaissementUpdated={onDecaissementUpdated}
                />
            ),
        },
        {
            key: "8",
            label: "Experts",
            children: (
                <ExpertsTab
                    sinistre={sinistre}
                    experts={experts}
                    expertises={expertises}
                    setRefetch={setRefetch}
                    editMode={editMode}
                    setEditMode={setEditMode}
                />
            ),
        },
        {
            key: "9",
            label: "Prises en charge",
            children: (
                <PrisesEnChargeTab
                    sinistre={sinistre}
                    setEditMode={setEditMode}
                    editMode={editMode}
                    setRefetch={setRefetch}
                />
            ),
        },
        {
            key: "10",
            label: "Offres",
            children: <OffresSection sinistre={sinistre} expertises={expertises} />,
        },
        {
            key: "11",
            label: "Documents et captures",
            children: (
                <DocumentsAFournir
                    sinistre={sinistre}
                    captured={captured}
                    captures={captures}
                    uploadedPieces={sinistre?.pieces}
                    documentsConfig={sinistre?.documentsAFournir}
                />
            ),
        },
        {
            key: "12",
            label: "Dicussions",
            children: <DiscussionsTab sinistre={sinistre} />,
        },
    ];

    return (
        <>
            <div className="card">
                <Spin spinning={loadingSinistre}>
                    <Tabs
                        onChange={onTabsChange}
                        type="card"
                        items={tabItems}
                        activeKey={tabId}
                    />
                </Spin>
            </div>
            <Modal
                title={editMode ? "MISE À JOUR RÉEVALUATION" : "REÉVALUATION"}
                centered
                open={modalReevaluation}
                onOk={(event) => handleSubmit(event, false)}
                onCancel={() => {
                    setEvaluation(initEvaluation);
                    setModalReevaluation(false);
                }}
            >
                <Card>
                    <CardBody>
                        <div className="grid container">
                            <div className="grid-item">
                                <div>
                                    <b>Ancienne provision :</b>{" "}
                                    <Tag color="blue">
                                        <b>
                                            {sinistre?.evaluation
                                                ? new Intl.NumberFormat("en-DE").format(sinistre?.evaluation)
                                                : "0"}{" "}
                                            FCFA
                                        </b>
                                    </Tag>
                                </div>
                                <br />

                                <div className="grid container" justify="center">
                                    <div className="grid-item" lg={12}>
                                        <div className="form-control">
                                            <Select
                                                mode="multiple"
                                                value={valueSelected}
                                                onChange={(value) => {
                                                    const previous = valueSelected || [];
                                                    if (value.length > previous.length) {
                                                        addProvisionFormFields();
                                                    } else {
                                                        const removed = previous.filter((current) => !value.includes(current));
                                                        if (removed.length) {
                                                            removeProvisionFormFields(removed[0]);
                                                        }
                                                    }

                                                    const garantiesSelectionnees = [];
                                                    value.forEach((valeur) => {
                                                        const garantie = garanties.find((gar) => gar.value === valeur);
                                                        if (garantie) {
                                                            garantiesSelectionnees.push(garantie.garantie);
                                                        }
                                                    });
                                                    setValueSelected(value);
                                                    setSelectedGaranties(garantiesSelectionnees);
                                                    setGarantieState(value.length ? "success" : "error");
                                                }}
                                                options={garanties}
                                                placeholder="Sélectionnez des garanties"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {selectedGaranties.length ? (
                                    <div className="grid container" style={{ justifyContent: "center" }}>
                                        {selectedGaranties.map((garantie, index) => (
                                            <div className="grid-item" key={garantie.codeId || index}>
                                                <label
                                                    htmlFor={`provision-${garantie.codeId || index}`}
                                                    style={{ margin: "30px 0 10px 0" }}
                                                >
                                                    Provision Garantie {garantie.nom} :
                                                </label>
                                                <Input
                                                    id={`provision-${garantie.codeId || index}`}
                                                    placeholder="Veuillez entrer la valeur de la provision"
                                                    value={provisionGaranties[index]?.provision}
                                                    onChange={(event) => {
                                                        const newProvisionFormFields = [...provisionGaranties];
                                                        newProvisionFormFields[index].garantie = garantie;
                                                        newProvisionFormFields[index].provision = event.target.value;
                                                        setProvisionGarantie(newProvisionFormFields);
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                                <br />
                                <div>
                                    <b>Nouvelle provision :</b>{" "}
                                    <Tag color="green">
                                        <b>
                                            {evaluation?.nouvelleProvision
                                                ? new Intl.NumberFormat("en-DE").format(evaluation?.nouvelleProvision)
                                                : "0"}{" "}
                                            FCFA
                                        </b>
                                    </Tag>
                                </div>

                                <br />
                                <div className="form-control">
                                    <Select
                                        id="motifRevision"
                                        name="motifRevision"
                                        placeholder="Motif de la révision"
                                        dropdownRender={(menu) => (
                                            <>
                                                {menu}
                                                <Divider style={{ margin: "8px 0" }} />
                                                <Space style={{ padding: "0 8px 4px" }}>
                                                    <Input
                                                        placeholder="Ajouter un motif"
                                                        ref={inputRef}
                                                        value={name}
                                                        onChange={onNameChange}
                                                    />
                                                    <Button
                                                        type="text"
                                                        icon={<PlusOutlined />}
                                                        onClick={addItem}
                                                    >
                                                        Ajouter un motif
                                                    </Button>
                                                </Space>
                                            </>
                                        )}
                                        options={items.map((item) => ({
                                            label: item,
                                            value: item,
                                        }))}
                                        onChange={(value) => {
                                            handleChange(value, "motifRevision");
                                            if (value.trim().length > 3) {
                                                setMotifRevisionState("success");
                                            } else {
                                                setMotifRevisionState("error");
                                            }
                                        }}
                                        value={evaluation.motifRevision}
                                    />
                                </div>
                                <br />
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Modal>
        </>
    );
};

export default Details;
